import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UploadAdditionalDocumentsService {

  constructor(private http: HttpClient) { }

  public getDasComments(appId):Observable<any>{
    return this.http.get(environment.BASE_URL_DAS+'das/getDasComments/'+appId)
  }
  public getDasCommentsForDas(appId):Observable<any>{
    return this.http.get(environment.BASE_URL_PCD+'api/das/'+appId+'/comments')
  }

  public getDesComments(appId,acronym):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/getComments/`+appId)
  }

  public submitAdditionalDocument(appId,profileId):Observable<any>{
    return this.http.get(environment.BASE_URL_DAS+'das/updateDetailsOnUploadDocuments/'+appId+'/'+profileId)
  }

  public getDasFormDetails(): Observable<any>{
    return this.http.get(environment.BASE_URL_DAS+'das/getInitFormData')
  }

  public getDocumentList(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getDocumentByAppIdAndAcronym',payload)
  }

  public deleteDocument(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/deleteByDocumentId',payload)
  }

  public getAttachmentByDocumentId(payload){
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getAttachmentByDocumentId',payload)
  }
}
